import React from "react";
import ReactMarkdown from "react-markdown";
import { ChevronLeft, Sparkles, Download, Copy } from "lucide-react";
import { copyText, downloadImage } from "./dockUtils";

export const SkillResultView = ({ skillResult, onBack }) => (
  <div className="p-4 overflow-y-auto custom-scroll flex-1" data-testid="skill-result-view">
    <button onClick={onBack} className="text-[11px] text-gray-500 hover:text-white mb-3 flex items-center gap-1">
      <ChevronLeft className="w-3 h-3" /> Volver
    </button>
    <p className="text-[10px] uppercase tracking-widest text-purple-400 mb-1">{skillResult?.skill?.label}</p>
    {skillResult?.error ? (
      <p className="text-xs text-red-300 mt-2">{skillResult.error}</p>
    ) : skillResult?.council ? (
      <>
        <div className="mt-3 space-y-3" data-testid="council-individual-responses">
          {skillResult.council.individual_responses?.map((r, i) => (
            <div key={`council-resp-${r.officer_name || i}`} className="p-3 rounded-xl bg-white/[0.03] border border-white/[0.06]">
              <p className="text-[10px] uppercase tracking-widest text-purple-300 font-semibold mb-1.5">{r.officer_name}</p>
              <div className="prose prose-invert prose-sm max-w-none text-gray-300 text-[11px] leading-relaxed">
                <ReactMarkdown>{r.answer}</ReactMarkdown>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 p-3 rounded-xl bg-gradient-to-br from-pink-500/[0.08] to-purple-500/[0.06] border border-pink-500/25" data-testid="council-synthesis">
          <p className="text-[10px] uppercase tracking-widest text-pink-300 font-semibold mb-1.5 flex items-center gap-1"><Sparkles className="w-3 h-3" /> Sintesis Ejecutiva</p>
          <div className="prose prose-invert prose-sm max-w-none text-white text-[11px] leading-relaxed">
            <ReactMarkdown>{skillResult.council.synthesis}</ReactMarkdown>
          </div>
        </div>
        <p className="text-[10px] text-gray-600 mt-3">Generado en {(skillResult.council.latency_ms / 1000).toFixed(1)}s</p>
      </>
    ) : skillResult?.items ? (
      <>
        <p className="text-[11px] text-gray-400 mt-2">{skillResult.total_generated}/10 imagenes generadas</p>
        <div className="grid grid-cols-2 gap-2 mt-3" data-testid="image-batch-grid">
          {skillResult.items.map((it, i) => (
            <div key={`img-batch-${it.caption?.slice(0, 20) || i}`} className="rounded-xl bg-white/[0.03] border border-white/[0.06] overflow-hidden">
              {it.image_b64 ? (
                <>
                  <img src={`data:${it.mime_type};base64,${it.image_b64}`} alt={it.caption} className="w-full aspect-square object-cover" />
                  <div className="p-2">
                    <p className="text-[10px] text-gray-300 leading-snug line-clamp-3">{it.caption}</p>
                    <button onClick={() => downloadImage(it.image_b64, it.mime_type, `post-${it.index}`)} className="mt-1.5 text-[10px] text-purple-300 hover:text-white transition-colors">Descargar</button>
                  </div>
                </>
              ) : (
                <div className="aspect-square flex items-center justify-center text-[10px] text-red-300 p-2 text-center">Error: {it.error}</div>
              )}
            </div>
          ))}
        </div>
      </>
    ) : (
      <>
        {skillResult?.image_b64 && (
          <div className="mt-3">
            <img
              src={`data:${skillResult.mime_type};base64,${skillResult.image_b64}`}
              alt="Generated"
              className="w-full rounded-xl border border-white/10"
            />
            <button
              onClick={() => downloadImage(skillResult.image_b64, skillResult.mime_type, skillResult.skill.id)}
              className="mt-2 w-full px-3 py-2 rounded-xl bg-white/5 hover:bg-white/10 text-white text-xs flex items-center justify-center gap-2 transition-colors"
              data-testid="skill-download-image"
            >
              <Download className="w-3 h-3" /> Descargar imagen
            </button>
          </div>
        )}
        {skillResult?.text && (
          <div className="mt-3 p-3 rounded-xl bg-white/[0.03] border border-white/[0.06]">
            <div className="prose prose-invert prose-sm max-w-none text-gray-200 text-xs leading-relaxed">
              <ReactMarkdown>{skillResult.text}</ReactMarkdown>
            </div>
            <button
              onClick={() => copyText(skillResult.text)}
              className="mt-2 px-2.5 py-1 rounded-lg bg-white/5 hover:bg-white/10 text-white text-[10px] flex items-center gap-1 transition-colors"
              data-testid="skill-copy-text"
            >
              <Copy className="w-3 h-3" /> Copiar
            </button>
          </div>
        )}
        {skillResult?.latency_ms && (
          <p className="text-[10px] text-gray-600 mt-3">Generado en {(skillResult.latency_ms / 1000).toFixed(1)}s</p>
        )}
      </>
    )}
  </div>
);
